import { render, staticRenderFns } from "./AttachmentLoader.vue?vue&type=template&id=1063ad94&scoped=true&"
import script from "./AttachmentLoader.vue?vue&type=script&lang=js&"
export * from "./AttachmentLoader.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentLoader.vue?vue&type=style&index=0&id=1063ad94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063ad94",
  null
  
)

export default component.exports